"use client"

import { cn } from "@/lib/utils"

/**
 * Secondary "Deposit" badge rendered alongside the invoice
 * ``StatusBadge`` when the invoice carries a deposit plan. The
 * partial/paid state itself is the existing status badge; this badge
 * only flags that the invoice is a deposit invoice (deposit-payments
 * spec §10.3 — "Deposit · Partially Paid").
 */
export function DepositBadge({
  className,
  testId = "deposit-badge",
}: {
  className?: string
  testId?: string
}) {
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex items-center px-2 py-0.5 rounded text-caption font-medium bg-info/10 text-info",
        className,
      )}
    >
      Deposit
    </span>
  )
}
